import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

interface ScrollToTopButtonProps {
  threshold?: number;
  containerSelector?: string;
  className?: string;
}

export const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  threshold = 250,
  containerSelector = 'main',
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const targetEl = containerSelector ? document.querySelector(containerSelector) : null;
      const scrollTop = Math.max(
        window.scrollY || 0,
        targetEl ? targetEl.scrollTop : 0
      );
      setIsVisible(scrollTop > threshold);
    };

    const targetEl = containerSelector ? document.querySelector(containerSelector) : null;
    if (targetEl) {
      targetEl.addEventListener('scroll', handleScroll, { passive: true });
    }
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Kezdeti ellenőrzés
    handleScroll();

    // Időzített ellenőrzés az esetleges DOM vagy route változások követésére
    const interval = setInterval(handleScroll, 1000);

    return () => {
      if (targetEl) targetEl.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScroll);
      clearInterval(interval);
    };
  }, [threshold, containerSelector]);

  const scrollToTop = () => {
    const targetEl = containerSelector ? document.querySelector(containerSelector) : null;
    if (targetEl && targetEl.scrollTop > 0) {
      targetEl.scrollTo({ top: 0, behavior: 'smooth' });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      // Kisebb, kerek gomb a sarokban; nyugalmi állapotban áttetsző, hogy ne takarja
      // a mögötte lévő sort (pl. a műveleti ikonokat), rámutatva / fókuszban teljes.
      className={`fixed bottom-4 right-4 z-50 w-10 h-10 rounded-full bg-blue-600/70 hover:bg-blue-600 focus-visible:bg-blue-600 text-white shadow-lg hover:scale-105 active:scale-95 transition-all duration-200 cursor-pointer flex items-center justify-center border border-blue-400/40 group animate-in fade-in zoom-in-90 select-none ${className}`}
      title="Ugrás az oldal tetejére"
      aria-label="Ugrás az oldal tetejére"
    >
      <ArrowUp className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
    </button>
  );
};
